import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./quill-fonts.css";

const Font = Quill.import("formats/font");

Font.whitelist = [
  "arial",
  "georgia",
  "verdana",
];

Quill.register(Font, true);

export default function RichText({ value, onChange }) {
  const modules = {
    toolbar: [
      [{ font: Font.whitelist }],

      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      ["bold", "italic", "underline", "strike"],

      [{ align: [] }],

      [{ list: "ordered" }, { list: "bullet" }],

      [{ color: [] }, { background: [] }],

      ["link"],

      ["clean"],
    ],
  };

  const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "align",
    "list",
    "bullet",
    "color",
    "background",
    "link",
  ];

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder="Type something..."
    />
  );
}